import React from 'react'

const ResponseLoadingScreen = (props) => {
        if(props.loading === true){
            return(
                <div className="the-loading-screen loading-for-response">
                    <div className="loading-screen-img-wrapper">
                        <div className="loading-logo"></div>
                        <h5 className="loading-for-response-text">Loading...</h5>
                    </div>
                </div>
            )
        }else {
            return null
        }
}
export default ResponseLoadingScreen